import { render } from "./EditMyInfo.vue?vue&type=template&id=b3a5b4de&scoped=true"
import script from "./EditMyInfo.vue?vue&type=script&lang=js"
export * from "./EditMyInfo.vue?vue&type=script&lang=js"

import "./EditMyInfo.vue?vue&type=style&index=0&id=b3a5b4de&scoped=true&lang=css"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3a5b4de"]])

export default __exports__